var map = {
	"./de/customerService.png": "Kkl1",
	"./en/customerService.png": "oCj4",
	"./es/customerService.png": "OT4p",
	"./fr/customerService.png": "w/oF",
	"./ja/customerService.png": "kLRq",
	"./ko/customerService.png": "xfpm",
	"./pt/customerService.png": "c7MT",
	"./ru/customerService.png": "WuuI",
	"./tc/customerService.png": "V5Aw",
	"./th/customerService.png": "JFlG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fAHH";